<template>
  <div class="app-container">
    <el-card class="mb5 searchContainer">
      <el-form label-position="top" :model="queryForm" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <!--费用名称-->
            <el-form-item :label="$t('basicData.ExpenseName')" prop="name">
              <el-input
                id="name"
                v-model="queryForm.params.name"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--业务类型-->
            <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
              <el-select
                id="businessType"
                v-model="queryForm.params.businessType"
                clearable
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%;"
              >
                <!--全部-->
                <el-option key="0" :label="$t('collectionCenter.tudo')" :value="null" />
                <el-option
                  v-for="item in PAYABLE_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--科目类型-->
            <el-form-item :label="$t('basicData.accountType')" prop="accountType">
              <el-select
                id="accountType"
                v-model="queryForm.params.accountType"
                clearable
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in SUBJECT_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--状态-->
            <el-form-item :label="$t('basicData.status')">
              <el-select
                v-model="queryForm.params.state" :placeholder="$t('GlobalSetObj.pleaseChoose')" clearable
                style="width: 100%;"
              >
                <!--全部-->
                <el-option :label="$t('collectionCenter.tudo')" :value="null" />
                <el-option :label="$t('basicData.enable')" :value="1" />
                <el-option :label="$t('basicData.disable')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('basicData.Attribute')">
              <el-select
                v-model="queryForm.params.property" clearable :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%"
              >
                <el-option
                  v-for="item in feeAttributeList"
                  :key="item.dictValue"
                  :value="item.dictValue"
                  :label="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!--查询-->
      <el-button
        type="primary"
        icon="el-icon-search"
        size="small"
        @click="getDataSearch(1)"
      >{{ $t('basicData.Search') }}
      </el-button>
      <!--重置-->
      <el-button
        icon="el-icon-refresh"
        size="small"
        @click="getDataSearch(2)"
      >{{ $t('basicData.reset') }}
      </el-button>
    </el-card>

    <el-card>
      <div class="mb10">
        <el-button
          v-permit:remove="'btn:finance:basicData:payable:feesType-editAdd'"
          type="primary"
          size="small"
          @click="addEdit(1)"
        >{{ $t('GlobalSetObj.append') }}
        </el-button>
      </div>
      <div>
        <el-table
          ref="elTableFeesType"
          :data="tableData"
          border
          class="table-height"
          :height="tableHeightRow.height"
        >
          <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
            <template slot-scope="scope">
              <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <!--费用名称-->
          <el-table-column
            prop="displayName"
            :label="$t('basicData.ExpenseName')"
            align="left"
            width="160"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div style="color: #00A551;cursor: pointer;" @click="addEdit(2, scope.row)">{{ scope.row.displayName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            :label="$t('basicData.FeeCode')"
            align="left"
            width="160"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.code }}</div>
            </template>
          </el-table-column>
          <!--业务类型-->
          <el-table-column
            prop="businessType"
            :label="$t('collectionCenter.businessT')"
            align="center"
            width="160"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ PAYABLE_TYPE[scope.row.businessType] && PAYABLE_TYPE[scope.row.businessType].label }}</span>
            </template>
          </el-table-column>
          <!--科目类型-->
          <el-table-column
            prop="accountType"
            :label="$t('basicData.accountType')"
            align="center"
            width="160"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ SUBJECT_TYPE[scope.row.accountType] && SUBJECT_TYPE[scope.row.accountType].label }}</span>
            </template>
          </el-table-column>
          <!--特殊规则-->
          <el-table-column
            prop="specialRules"
            :label="$t('basicData.SpecialRules')"
            align="center"
            width="160"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ SPECIAL_RULES_OBJ[scope.row.specialRules] }}</span>
            </template>
          </el-table-column>
          <!--状态-->
          <el-table-column
            prop="state"
            :label="$t('basicData.status')"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <!--启用-->
              <el-tag v-if="scope.row.state" type="success">{{ $t('basicData.enable') }}</el-tag>
              <!--禁用-->
              <el-tag v-else type="danger">{{ $t('basicData.disable') }}</el-tag>
            </template>
          </el-table-column>
          <!--属性-->
          <el-table-column
            :label="$t('basicData.Attribute')"
            align="center"
            prop="property"
            width="140"
          />
          <!--创建人-->
          <el-table-column
            prop="createUserStr"
            :label="$t('basicData.CreatePeople')"
            align="center"
            width="120"
            :show-overflow-tooltip="true"
          />
          <!--创建时间-->
          <el-table-column
            prop="createTime"
            :label="$t('basicData.CreationTime')"
            align="center"
            width="160"
            :show-overflow-tooltip="true"
          />
          <!--最后修改人-->
          <el-table-column
            prop="updateUserStr"
            :label="$t('basicData.LastModifier')"
            align="center"
            width="120"
            :show-overflow-tooltip="true"
          />
          <!--最后修改时间-->
          <el-table-column
            prop="updateTime"
            :label="$t('basicData.LastModified')"
            align="center"
            width="160"
            :show-overflow-tooltip="true"
          />
          <!--备注-->
          <el-table-column
            prop="remark"
            :label="$t('basicData.remark')"
            align="left"
            :show-overflow-tooltip="true"
            width="200"
          />
          <el-table-column
            :label="$t('basicData.operate')" fixed="right" width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                <!--确定禁用吗？-->
                <el-popconfirm
                  v-if="scope.row.state"
                  v-permit:remove="'btn:finance:basicData:payable:feesType-editAdd'"
                  :title="$t('basicData.AreYouSureDisabled')"
                  @confirm="asyncPartitionEdit(scope.row, 0)"
                >
                  <!--禁用-->
                  <el-button
                    slot="reference" class="ml" type="warning"
                    size="small"
                  >{{ $t('basicData.disable') }}</el-button>
                </el-popconfirm>
                <!--确定启用吗？-->
                <el-popconfirm
                  v-if="!scope.row.state"
                  v-permit:remove="'btn:finance:basicData:payable:feesType-editAdd'"
                  :title="$t('basicData.AreYouSureEnabled')"
                  @confirm="asyncPartitionEdit(scope.row, 1)"
                >
                  <!--启用-->
                  <el-button
                    slot="reference" class="ml" type="primary"
                    size="small"
                  >{{ $t('basicData.enable') }}</el-button>
                </el-popconfirm>
                <!--删除-->
                <el-popconfirm
                  v-permit:remove="'btn:finance:basicData:payable:feesType-editAdd'"
                  :title="$t('basicData.AreYouSureYouWantToDelete')"
                  @confirm="deleteAccount(scope.row)"
                >
                  <!--删除-->
                  <el-button
                    slot="reference" class="ml" type="danger"
                    size="small" style="margin-left: 10px;"
                  >{{ $t('basicData.Delete') }}</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页工具 -->
        <div class="pagination">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="queryForm.pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="queryForm.pageSize"
            :total="total"
            background
            style="margin: 10px 0"
            @current-change="currencyChangeTableData"
            @size-change="sizeChangeTableData"
          />
        </div>
      </div>
    </el-card>
    <!-- 费用类型添加、修改 -->
    <el-drawer
      :visible.sync="drawerObj.visible"
      :title="drawerObj.typeIndex === 1 ? $t('basicData.AddAFee') : $t('basicData.FeeDetails')"
      direction="ltr"
      size="60%"
    >
      <check-detail
        v-if="drawerObj.visible"
        :key="editKey"
        :detail-data="drawerObj.editData"
        :operation-type="drawerObj.typeIndex"
        :fee-attribute-list="feeAttributeList"
        @saveChange="saveChange"
      />
    </el-drawer>
  </div>
</template>

<script>
import { editStatusFee, feeDelete, feePage } from '@/api/finance/partition';
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { SUBJECT_TYPE } from '@/views/finance/utils.js';
import { PAYABLE_TYPE } from '@/views/finance/enums';
import { SPECIAL_RULES_OBJ } from './consts';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';

export default {
  // name: 'FeesTypeCope',

  components: {
    checkDetail: () => import('./cmp/checkDetail.vue')
  },

  mixins: [estimateTableHeight, toolRequestClass],

  data() {
    return {
      SPECIAL_RULES_OBJ,
      PAYABLE_TYPE,
      SUBJECT_TYPE,
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          name: '', // 名称
          businessType: null, // 业务类型 1 安骏 2 第三方 3 AJD 4 DSP 5 运输干支线 6 邮局
          accountType: null, // 科目类型
          attribute: 2, // 用于区分应付or应收
          state: null,
          property: null
        }
      },
      tableData: [],
      total: 0,
      drawerObj: {
        visible: false,
        typeIndex: 1,
        editData: {
          name: '',
          namePu: '',
          remark: '',
          state: true,
          // operationMode: 1, // 经营模式 默认自营
          businessType: null,
          collectType: null,
          accountType: null,
          id: '',
          attribute: 2 // 用于区分应付or应收
        }
      },
      editKey: new Date().getTime(),
      userIdAndNameObj: null
    };
  },
  created() {
    this.userIdAndNameObj = getUserIdAndNameObj();
    this.getTableDataList();
    this.getFeeAttribute({ dictCode: 'YF_FYLX_SX' });
  },
  methods: {
    // 搜索、重置
    getDataSearch(type) {
      this.queryForm.pageNumber = 1;
      if (type === 2) {
        this.queryForm.params.name = '';
        this.queryForm.params.businessType = null;
        this.queryForm.params.accountType = null;
        this.queryForm.params.state = null;
        this.queryForm.params.property = null;
      }
      this.getTableDataList();
    },
    // 编辑保存
    saveChange(type) {
      this.drawerObj = {
        visible: false,
        typeIndex: 1,
        editData: {
          name: '',
          namePu: '',
          remark: '',
          state: true,
          businessType: null,
          collectType: null,
          id: '',
          attribute: 2
        }
      };
      if (type === 1) {
        this.getTableDataList();
      }
    },
    // 添加、编辑
    addEdit(type, row) {
      if (type === 1) {
        this.drawerObj.editData = {
          code: '',
          name: '',
          namePu: '',
          remark: '',
          state: true,
          businessType: null,
          collectType: null,
          accountType: null,
          id: '',
          attribute: 2,
          specialRules: '',
          property: null
        };
      } else {
        const { code, name, namePu, id, remark, state, operationMode, businessType, collectType, attribute, ajdDetailsList, taxationType, taxBase, reduction, ajdId, accountType, specialRules, property } = row;
        const obj = {
          code,
          name,
          namePu,
          id,
          remark,
          state,
          operationMode,
          businessType,
          accountType,
          collectType,
          attribute,
          ajdDetailsList,
          taxationType,
          taxBase,
          reduction,
          ajdId,
          property,
          specialRules: specialRules ? specialRules.toString() : ''
        };

        obj.attribute = 2;

        Object.assign(this.drawerObj.editData, obj);
      }
      this.drawerObj.typeIndex = type;
      this.drawerObj.visible = true;
      this.editKey = new Date().getTime();
    },
    // 启用、禁用
    asyncPartitionEdit(row, type) {
      const param = {
        id: row.id,
        state: type
      };
      editStatusFee(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // 操作成功
          this.getTableDataList();
        }
      });
    },
    // 删除
    deleteAccount(row) {
      feeDelete({ id: row.id }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded')); // 操作成功
          this.getTableDataList();
        }
      });
    },
    // 获取费用类型列表
    getTableDataList() {
      feePage(this.queryForm).then(res => {
        if (res.code === 200) {
          const { data } = res;
          this.tableData = data.records.map(item => {
            const updateUserStr = getUserName(item.updateUser, this.userIdAndNameObj);
            const createUserStr = getUserName(item.createUser, this.userIdAndNameObj);
            for (const key in item) {
              if (key === 'createTime' || key === 'updateTime') {
                item[key] = item[key] ? item[key].replace('T', ' ') : '';
              }
            }
            return Object.freeze({
              ...item,
              updateUserStr,
              createUserStr
            });
          });
          this.total = data.total;
        }
      });
    },
    // 翻页
    currencyChangeTableData(val) {
      this.queryForm.pageNumber = val;
      this.getTableDataList();
    },
    // 每页显示数量切换
    sizeChangeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getTableDataList();
    }
  }
};
</script>

<style scoped>

</style>
